import { defineComponent as _defineComponent } from 'vue'
import { StorageController } from "@rmp/core/api/storage";
import RmpBtn from "@rmp/core/components/buttons/RmpBtn.vue";
import RmpLabel from "@rmp/core/components/fields/RmpLabel.vue";
import RmpIcon from "@rmp/core/components/icon/RmpIcon.vue";
import { FileMeta, FileMetaHelper } from "@rmp/core/types/storage/fileMeta";
import AbortService from "@rmp/core/services/abortService";
import { useFileDownload } from "@rmp/core/composables/useFileDownload";
import { computed, onBeforeMount, ref, useSlots } from "vue";
import RmpTextBtn from "@rmp/core/components/buttons/RmpTextBtn.vue";
import { useAppStore } from "@rmp/core/stores/appStore";
import { useFilePreviewStore } from "@rmp/core/stores/filePreview";

interface Props {
	deletable?: boolean,
	noIcon?: boolean,
	downloadable?: boolean,
	id?: string,
	name?: string,
	label?: string,
	uploading?: boolean,
	required?: boolean,
	downloadBtn?: boolean,
	btnOnly?: boolean,
	color?: string,
	maxWidth?: string,
	textWrap?: boolean,
	dense?: boolean,
	previewable?: boolean,
	subtitlePrefix?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RmpFile',
  props: {
    deletable: { type: Boolean },
    noIcon: { type: Boolean },
    downloadable: { type: Boolean, default: true },
    id: null,
    name: { default: "" },
    label: null,
    uploading: { type: Boolean },
    required: { type: Boolean },
    downloadBtn: { type: Boolean },
    btnOnly: { type: Boolean },
    color: null,
    maxWidth: { default: "100%" },
    textWrap: { type: Boolean },
    dense: { type: Boolean, default: false },
    previewable: { type: Boolean, default: true },
    subtitlePrefix: null
  },
  emits: ["update:meta", "delete"],
  setup(__props: any, { emit: emits }) {

const props = __props as { deletable?: boolean, noIcon?: boolean, downloadable: boolean, id?: string, name: string, label?: string, uploading?: boolean, required?: boolean, downloadBtn?: boolean, btnOnly?: boolean, color?: string, maxWidth: string, textWrap?: boolean, dense: boolean, previewable: boolean, subtitlePrefix?: string };





const abortService = new AbortService();
const storageController = new StorageController(abortService);

const loading = ref<boolean>(false);
const meta = ref<FileMeta>({} as FileMeta);

const { downloading, download: downloadFile } = useFileDownload();

const filename = computed(() => {
	if(props.name) return props.name;
	
	return meta.value.name;
});

const displayFilename = computed(() => {
	const name = filename.value || "";
	return name.length > 40 ? `${name.slice(0, 19)}...${name.slice(-18)}` : name;
});

onBeforeMount(() => {
	abortService.initialize();
	if(props.id && !props.name) getMeta();
});

const download = async () => {
	if(!props.id || !props.downloadable) return;

	await downloadFile(props.id, meta.value.name || props.name);
};
const getMeta = async () => {
	loading.value = true;
	
	try {
		const apiMeta = await storageController.getFileMeta(props.id as string);
		meta.value = FileMetaHelper.map(apiMeta);
		
		loading.value = false;
		
		emits("update:meta", meta.value);
	} catch (error) {
		useAppStore().handleActionError(error);
	}
};

const previewAvailable = computed(() => {
	return props.previewable && Boolean(props.id) && !props.uploading;
});

const slots = useSlots();
const loadingMargin = computed(() => {
	if(!props.dense || props.label || props.downloadBtn || props.btnOnly || slots.append || slots["append-outer"] || slots.alert) return 12;

	if(props.deletable && !props.uploading) return 8;

	return previewAvailable.value ? 6 : 4;
});

const openPreview = (event: MouseEvent) => {
	(event.target as Element)?.closest("button")?.blur();
	
	useFilePreviewStore().open({
		fileId: props.id as string,
		fileName: filename.value,
		documentLabel: props.label,
		subtitle: props.subtitlePrefix ? `${props.subtitlePrefix} - ${filename.value}` : undefined
	});
};

const textBtnStyle = computed(() => {
	const style = {
		pointerEvents: !props.downloadable ? "none" : "unset"
	};
	
	return props.textWrap ?
		Object.assign(style, {
			whiteSpace: "pre-wrap !important"
		}) : Object.assign(style, {
			textOverflow: "ellipsis",
			overflowWrap: "break-word",
			wordBreak: "break-all"
		});
	
	
});

return { __sfc: true,props, emits, abortService, storageController, loading, meta, downloading, downloadFile, filename, displayFilename, download, getMeta, previewAvailable, slots, loadingMargin, openPreview, textBtnStyle, RmpBtn, RmpLabel, RmpIcon, RmpTextBtn }
}

})